import {SvgIcon} from "@material-ui/core";

export const CustomApplication2ListIcon = (props) => {
    return (
        <SvgIcon width="20" height="21" viewBox="0 0 20 21" fill="#CDBDDB" {...props}>
            <path d="M16.667 6.37402H8.33366V11.374H6.66699V4.70736H11.667V1.37402H5.00033V6.37402H3.33366C2.41699 6.37402 1.66699 7.12402 1.66699 8.04069V18.0407C1.66699 18.9574 2.41699 19.7074 3.33366 19.7074H16.667C17.5837 19.7074 18.3337 18.9574 18.3337 18.0407V8.04069C18.3337 7.12402 17.5837 6.37402 16.667 6.37402Z"/>
        </SvgIcon>
    )
}